import {
  setUniqueArrayOfObjects,
  generateQueryStringWithKeysRepeat,
} from "@/shared/utils";

export default function setup() {
  const LOCAL_STORAGE_NAME = "dashboard-parvandeh-codes";
  const getMergedItems = () => {
    const storageData = localStorage.getItem(LOCAL_STORAGE_NAME);
    const storageItems = JSON.parse(storageData) || [];
    const uniqueItems = setUniqueArrayOfObjects(storageItems, "code");
    return uniqueItems;
  };
  const generateParvandehQueryString = (extraQueryStrings = null) => {
    const items = getMergedItems();
    if (!items.length) return "";

    const codesArray = items.map((row) => row.code);
    const queryString = generateQueryStringWithKeysRepeat(
      codesArray,
      "parvandeh_code",
      extraQueryStrings
    );
    return queryString;
  };
  const generateItemsOfStorage = (items, parvandehItems) => {
    const storageData = localStorage.getItem(LOCAL_STORAGE_NAME);
    const storageItems = JSON.parse(storageData) || [];
    const output = items.map((item) => {
      const oldItem = parvandehItems.find(
        ({ parvandehNumber }) => parvandehNumber === item.parvandehNumber
      );
      const storageItem = storageItems.find(
        ({ parvandehNumber }) => parvandehNumber === item.parvandehNumber
      );
      return { ...oldItem, ...storageItem, ...item };
    });
    return output;
  };

  return {
    getMergedItems,
    generateParvandehQueryString,
    generateItemsOfStorage,
  };
}
